<template>
  <div>
    <button type="button"
            @click="copyId"
            class="copy-btn">
      <copy-icon></copy-icon>
      <transition name="fade">
        <div v-show="show" class="copy-tooltip">
          {{$t('labels.coped')}}
        </div>
      </transition>
    </button>
  </div>
</template>

<script>
  import copyIcon from './Svg/things/copyLinkIcon'

  export default {
    name: 'copyBtnHint',
    props: {
      value: {
        type: String || Number
      }
    },
    components: {
      copyIcon
    },
    data() {
      return {
        show: false
      }
    },
    methods: {
      copyId() {
        let text = document.createElement('input');
        text.value = this.value;
        document.body.appendChild(text);
        text.select();
        document.execCommand('copy');
        document.body.removeChild(text);
        this.show = true;
        setTimeout(()=> this.show = false, 2000)
      }
    }
  }
</script>

<style lang="scss" >
  .copy-btn {
    position: relative;
    margin-left: 0;

    svg {
      width: 30px;
    }

    &:hover {
      svg {
        opacity: 1;
      }

      svg path {
        fill: $lightBlue;
        fill-opacity: 1;
      }
    }


    .copy-tooltip {
      position: absolute;
      width: 130px;
      background: #D7E3EA;
      left: calc(50% - 65px);
      bottom: calc(100% + 7px);
      font-family: MM, Arial, sans-serif;
      font-size: 12px;
      letter-spacing: 0.25px;
      text-align: center;
      padding: 5px;
      border-radius: 2px;
      color: $darkBlue;

      &::before {
        content: '';
        position: absolute;
        width: 11px;
        height: 11px;
        background: #D7E3EA;
        transform: rotate(45deg);
        left: 43%;
        bottom: -5px
      }
    }

    .copy-field {
      /*opacity: 0;*/
      //z-index: -999;
      //position: absolute;
      //height: 0 !important;
      //padding: 0 !important;
    }
  }
</style>
